export default "__VITE_ASSET__CjyKa_EN__"